import { Directive, inject } from '@angular/core';
import { KeyboardAdapter } from '@games/core/input/KeyboardAdapter';

@Directive()
export abstract class AbstractInputLayoutComponent {
  readonly keyboardAdapter = inject(KeyboardAdapter);
}
